import styled from 'styled-components';

export const StoreCard = styled.div`
  height: 230px;
  width: 230px;
  border-radius: 22px;
  border: 1px solid #000;
  background: #fff;
  padding: 20px;
  box-shadow: 4px 4px #000;

  @media (max-width: 515px) {
    height: 185px;
    width: 185px;
  }
  @media (max-width: 443px) {
    height: 150px;
    width: 150px;
  }

  @media (max-width: 351px) {
    height: 125px;
    width: 125px;
  }

  .Logo {
    width: 100%;
    height: 118px;

    @media (max-width: 515px) {
      height: 82px;
    }
    @media (max-width: 443px) {
      height: 65px;
    }
    @media (max-width: 351px) {
      height: 55px;
    }
  }
  .Span {
    width: 100%;
    height: 42px;
    margin-top: 10px;

    @media (max-width: 515px) {
      height: 30px;
    }
    @media (max-width: 443px) {
      height: 25px;
    }
    @media (max-width: 351px) {
      height: 20px;
    }
  }
`;
